import React, { useEffect } from "react";
import { THANK_YOU_PAGE_TYPES } from "../../../../config/const";
import { useNavigate, useParams } from "react-router-dom";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

const ThankYouPage = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // If not valid type , then redirect back
    if (!Object.values(THANK_YOU_PAGE_TYPES).some((s) => s == Number(type))) {
      navigate("/home");
    }

    // Automatically redirect to home after 5 sec
    setTimeout(() => {
      navigate("/home");
    }, 5000); // 5 sec
  }, []);

  return (
    <>
      <HeaderAfterLogin />
      <div className="container-fluid text-white text-center d-flex justify-content-center align-items-center h-100 thankyousection">
        <img src={"/images/thankyou.png"} alt="" />
        <div className="thankyou_text">
          <h1>Thank You!</h1>
          {/* <p>We appreciate your feedback.</p>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry
        </p> */}
          <div
            className="btn homebtn"
            onClick={() => {
              navigate("/home");
            }}
          >
            Go to Home
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default ThankYouPage;
